/**
 * Клиентские маршруты SPA.
 *
 * Ни один из них не начинается с `/api` — это пространство целиком принадлежит
 * бэкенду портала, поэтому фронт и бэк спокойно живут на одном домене.
 */
export const ROUTES = {
  /** Витрина: зачем нужен API и как он устроен. Первый пункт бокового меню. */
  home: "/",
  /** Документация — точка входа с квикстартом и каталогом моделей. */
  overview: "/docs",
  catalog: "/models",
  model: "/models/:slug",
  mcp: "/mcp",
  skills: "/skills",
  skill: "/skills/:skillId",
  tasks: "/tasks",
  frames: "/frames",
  workspaces: "/projects",
  endpoints: "/reference",
} as const;

export const modelPath = (slug: string): string => `/models/${slug}`;

export const skillPath = (id: string): string => `/skills/${id}`;
